import { Fragment, useState } from 'react'
import { Asset, renderIcon, kuiperClassNames } from '@opallabs/kuiper'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import { ContentTextInput } from '../../../../../ContentTextInput'
import { mediaControlsAtTop } from '../../../../helpers/styles'
import { sharedColors } from '../../../sharedStyles/styles'
import { IconBarItem, MobileSingleProps } from '../../types'
import * as styles from './styles'

const EMPTY_COLLAB_LABEL = 'No collab account'

export const MobileSingle = ({
  accountImage,
  collabEnabled,
  collabAccount,
  content,
  isPresenting,
  isSnapshot,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  onSoundChange,
  paidPromotion,
  readOnly,
  sound,
  username,
  video,
}: MobileSingleProps) => {
  const [isHovered, setIsHovered] = useState(false)

  const iconBarItems: IconBarItem[] = [
    { icon: 'youtube-mobile-short-like', text: 'Like' },
    {
      icon: 'youtube-mobile-short-dislike',
      text: 'Dislike',
    },
    {
      icon: 'youtube-mobile-short-comment',
      text: '###',
    },
    {
      icon: 'youtube-mobile-short-share',
      text: 'Share',
    },
    {
      icon: 'youtube-mobile-short-remix',
      text: 'Remix',
    },
    {
      icon: 'youtube-mobile-short-sound',
      text: null,
    },
  ]

  return (
    <Fragment>
      <div
        css={mediaControlsAtTop}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Asset
          hasAssetOverlay={!isSnapshot && (Boolean(video) || isPresenting)}
          disableCoverAsset={false}
          assetReference={video ?? null}
          imageFit="contain"
          readOnly={readOnly}
          isHovered={isHovered}
          placeholder={true}
          preview={isSnapshot}
          removeable={!isPresenting}
          onEmbiggen={() => video?.id && onExpandAsset(video.id)}
          onRemove={() => video?.id && onRemoveAsset(video.id)}
        />
      </div>

      <div
        css={styles.contentWrapper}
        className={kuiperClassNames('youtube-post-content')}
        onMouseEnter={() => setIsHovered(false)}
      >
        {paidPromotion && (
          <div css={styles.paidPromotion}>
            {renderIcon('youtube-mobile-short-promotion', {
              height: 16,
              width: 20,
              ariaMode: 'hidden',
            })}
            <span>Includes paid promotion</span>
            {renderIcon('youtube-mobile-short-chevron-east', {
              height: 12,
              width: 7,
              ariaMode: 'hidden',
            })}
          </div>
        )}
        <div
          className={kuiperClassNames('youtube-username')}
          css={styles.accountWrapper}
        >
          <ContentAvatar
            assetReference={accountImage}
            size={26}
            style={styles.accountAvatar}
          />
          {collabEnabled && (
            <ContentAvatar
              assetReference={null}
              size={26}
              style={styles.collabAvatarSecondary}
            />
          )}
          <div
            css={styles.nameRow}
            className={kuiperClassNames({ [styles.withCollab]: collabEnabled })}
          >
            <AccountName
              color={sharedColors.white}
              noAccountColor={sharedColors.orange}
              name={username ? `@${username}` : username}
              size={14}
            />
            {collabEnabled && (
              <>
                <span style={styles.collabSeparator}> and </span>
                <AccountName
                  color={
                    collabAccount ? sharedColors.white : sharedColors.orange
                  }
                  name={
                    collabAccount ? `@${collabAccount}` : EMPTY_COLLAB_LABEL
                  }
                  size={14}
                />
              </>
            )}
          </div>
        </div>
        <div css={styles.captionAndSoundWrapper}>
          <ContentTextInput
            characterCounterOptions={{ position: 'right', offset: 42 }}
            characterLimit={100}
            highlightSocialTags={true}
            maxRows={3}
            minRows={1}
            onChange={onContentChange}
            placeholder="Add caption..."
            placeholderStyle={styles.inputPlaceholder}
            readOnly={readOnly}
            style={styles.captionInput(readOnly)}
            value={content || ''}
          />
          <div css={styles.postContentSound}>
            {renderIcon('youtube-mobile-short-note', {
              ariaMode: 'hidden',
            })}
            <ContentTextInput
              maxRows={1}
              onChange={onSoundChange}
              placeholder="Add sound..."
              placeholderStyle={styles.inputPlaceholder}
              readOnly={readOnly}
              style={styles.soundInput(readOnly)}
              value={sound || ''}
            />
          </div>
        </div>
      </div>

      <div
        css={styles.iconsBar}
        className={kuiperClassNames('youtube-post-icons-bar')}
      >
        <ul>
          {iconBarItems.map((item) => (
            <li css={styles.iconBarItem} key={item.icon}>
              {item.icon === 'youtube-mobile-short-sound' ? (
                <div css={styles.soundIconWrapper}>
                  {renderIcon(item.icon, {
                    height: 20,
                    width: 18,
                    ariaMode: 'hidden',
                  })}
                </div>
              ) : (
                <Fragment>
                  {renderIcon(item.icon, {
                    height: 20,
                    width: 20,
                    ariaMode: 'hidden',
                  })}
                  <span>{item.text}</span>
                </Fragment>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div
        css={styles.bottomGradient}
        className={kuiperClassNames('youtube-gradient-layer')}
      />
    </Fragment>
  )
}
